export default "__VITE_ASSET__DpSXehsF__"